import { useState } from "react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { downloadQaDataReport } from "../../lib/api";
import { triggerBlobDownload } from "../../lib/download";

export default function QaDataTab() {
  const [qaSchoolYear, setQaSchoolYear] = useState("2025-2026");
  const [downloadingQa, setDownloadingQa] = useState(false);

  const handleDownloadQaData = async () => {
    setDownloadingQa(true);
    try { const res = await downloadQaDataReport(qaSchoolYear); triggerBlobDownload(new Blob([res.data]), `SMARTIS_QA_Data_${qaSchoolYear}.xlsx`); toast.success("QA Data report downloaded"); }
    catch { toast.error("Failed to generate QA Data report"); }
    finally { setDownloadingQa(false); }
  };

  return (
    <Card>
      <CardHeader><CardTitle>QA Data Report</CardTitle><CardDescription>Download the comprehensive Quality Assurance data report as an Excel workbook. Includes attendance, incidents by type, incidents by student, staff involvement, and accident/injury summary.</CardDescription></CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-end gap-4">
          <div className="space-y-2"><Label>School Year</Label><Select defaultValue="2025-2026" onValueChange={(v) => setQaSchoolYear(v)}><SelectTrigger className="w-48" data-testid="qa-school-year-select"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="2024-2025">2024-2025</SelectItem><SelectItem value="2025-2026">2025-2026</SelectItem><SelectItem value="2026-2027">2026-2027</SelectItem></SelectContent></Select></div>
          <Button onClick={handleDownloadQaData} disabled={downloadingQa} className="bg-[#00305E] hover:bg-[#00305E]/90" data-testid="download-qa-data-btn">{downloadingQa ? "Generating..." : "Download QA Data (.xlsx)"}</Button>
        </div>
        <div className="bg-muted/50 rounded-lg p-4 text-sm space-y-2">
          <p className="font-medium">Included Sheets:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1">
            <li><span className="font-medium text-foreground">Attendance</span> - Daily attendance with enrollment, hours, and percentages</li>
            <li><span className="font-medium text-foreground">Incidents by Type</span> - Monthly breakdown across 14 incident categories</li>
            <li><span className="font-medium text-foreground">Incidents by Student</span> - Monthly incident counts per student</li>
            <li><span className="font-medium text-foreground">Staff Involved</span> - Monthly reports filed by each staff member</li>
            <li><span className="font-medium text-foreground">Accident/Injury Summary</span> - Accident details and monthly medical response summary</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}
